import {Component, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE, EMPTY_USER, EVOL_DEMO_LAST_YEAR, PRICE_EVOL_LEGENT} from '@models/empty';
import {User} from '@models/user';
import {environment} from '~/environments/environment';
import {CityService} from '@services/city.service';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import * as htmlToImage from 'html-to-image';
import {jsPDF} from 'jspdf';
import {PdfConfig} from '@models/pdf';
import * as _ from 'underscore';
import * as $ from 'jquery';
import {UserService} from '@services/user.service';
import {MatDialog} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-pdf',
    templateUrl: './pdf.component.html',
    styleUrls: ['./pdf.component.scss']
})
export class PdfComponent implements OnInit {

    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    user: User = Object.assign({}, EMPTY_USER);
    pdfConfig: PdfConfig;

    fontSize = 22;
    params;
    result: any[] = [];
    displayedColumns: string[] = [];
    amort_moy = 0;
    apiUrl = environment.apiUrl;
    hideUnit = false;
    imgDone: string[] = [];
    imgAnnonce = '';
    imgSecteur = '';
    imgSecteurBis = '';
    imgAnalyse = '';
    imgWork = '';
    imgFinance = '';
    imgPatrimoniale = '';
    imgFiscal = '';
    ready = false;
    loading = false;
    enrichment = 0;
    config = '';

    data_CF_cum = [];

    advice_price = 0;
    rand = Math.floor(Date.now() / 1000);

    stripe = Stripe(environment.stripeKey);

    /**
     * Chart repartition
     */
    chargeEchartsIntance = null;
    chargeOptions = {
        tooltip: {
            trigger: 'item',
            formatter: '{c}€ ({d}%)'
        },
        legend: {
            orient: 'vertical',
            right: '0px',
            top: '30px',
            align: 'right',
            textStyle: {
                fontSize: 14,
            },
        },
        calculable: true,
    };
    chargeData = {
        series: []
    };

    /**
     * Chart price evol
     */
    priceEvolEchartsIntance = null;
    priceEvolOptions = {
        legend: {
            orient: 'vertical',
            right: '20px',
            bottom: '40px',
            align: 'right',
            selected: {},
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '10',
            bottom: '15',
            containLabel: true,
        },
        xAxis: {
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        yAxis: {
            type: 'value',
            label: {
                formatter: '{b} <br/>{a} : {c} €/m²',
            },
            min: 10000,
            axisLabel: {
                formatter: '{value} €/m²',
                fontSize: 12
            }
        },
        color: ['#2980B9', '#8E44AD ', '#C0392B', '#E67E22'],
        series: []
    };
    priceEvolData = {
        series: [],
    };

    /**
     * Chart prix
     */
    priceEchartsIntance = null;
    priceOptions = {
        label: {
            show: true,
            position: 'insideRight',
            color: 'white',
            fontSize: 16,
            formatter: d => {
                return d.data > 0 ? parseFloat(d.data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }) + '/m²' : '';
            }
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            max: 1,
        },
        yAxis: {
            type: 'category',
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        color: ['#54b0ed', '#1277AA'],
        series: []
    };
    priceData = {
        series: [],
    };

    /**
     * Chart Loyer
     */
    rentEchartsIntance = null;
    rentOptions = {
        label: {
            show: true,
            position: 'insideRight',
            color: 'white',
            fontSize: 16,
            formatter: d => {
                return d.data > 0 ? parseFloat(d.data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }) + '/m²' : '';
            }
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            max: 1,
        },
        yAxis: {
            type: 'category',
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        color: ['#54b0ed', '#1277AA'],
        series: []
    };
    rentData = {
        series: [],
    };

    // Graphique Evolution du capital net
    capitalEchartsIntance = null;
    options_Evol_Capital = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                let lib = 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
                return lib;
            },
        },
        legend: {},
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 16
                },
                axisLabel: {
                    fontSize: 16,
                },
                data: []
            }
        ],

        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value} €',
                    fontSize: 16,
                }
            },
        ],
        series: []
    };
    capitalData = {
        series: [],
    };

    // Graphique évolution du cash flow
    cashflowEchartsIntance = null;
    optionsCF = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                return 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
            },
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        legend: {},
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 15
                },
                data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                axisPointer: {}
            }
        ],
        yAxis: [
            {
                type: 'value',
                // name: 'Loyers et charges',
                axisLabel: {
                    formatter: '{value} €'
                }
            },
        ],
        series: []
    };
    cashflowData = {
        series: [],
    };

    // Graphique évolution de la population
    popEchartsIntance = null;
    popOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: '{a} <br/>{b} : {c}'
        },
        grid: [{
            left: '10px',
            right: '10px',
            top: '10px',
            bottom: '20px',
            containLabel: true
        }],
        xAxis: {
            type: 'category',
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
        },

        yAxis: {
            type: 'value',
            min: 1000000,
        },
        color: ['#5FB761'],

        series: []

    };

    popData = {};

    // Entreprise
    shopOptions = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d}%)'
        },
        legend: {
            orient: 'vertical',
            left: '0px',
            top: '0px',
            align: 'left',
            selectedMode: false,
            data: ['Grande distribution', 'Santé', 'Shopping', 'Commerces de proximité', 'Magasins pour la maison', 'Autres']
        },
        calculable: true,
    };

    shopData = {
        series: []
    };

    // Ecoles
    schoolOptions = {
        // title: {
        //     text: 'Nightingale\'s Rose Diagram',
        //     subtext: 'Mocking Data',
        //     x: 'center'
        // },
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d}%)'
        },
        legend: {
            orient: 'vertical',
            left: '0px',
            top: '0px',
            align: 'left',
            selectedMode: false,
            data: ['Enfance', 'Lycée', 'Enseignement supérieur', 'Formations']
        },
        calculable: true,
    };


    schoolData = {
        series: []
    };
    // Contact
    pro_data = {
        mobile: '',
    };

    title = '';

    constructor(
        public cityService: CityService,
        private http: HttpClient,
        private route: ActivatedRoute,
        private adService: AdService,
        private userService: UserService,
        public authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private alertService: AlertService,
        public deviceService: DeviceDetectorService,
        public trackingService: TrackingService,
        private router: Router) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.config = params.config;
            switch (params.config) {
                case 'lybox':
                    this.pdfConfig = {
                        template: ['classique'],
                        societe: 'LyBox',
                        logo_w: 532,
                        logo_h: 160,
                        logo_url: 'assets/logo/logo-inline.png',
                        logo_small_w: 532,
                        logo_small_h: 160,
                        logo_small_url: 'assets/logo/logo-inline.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: true,
                        display_contact: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: ``,
                        contact_bkg: '#1A3656',
                        h2_class: 'center',
                        h2_underline_url: '',
                        h3_class: 'center',
                        font_family: 'Rubik',
                        text_color: '#1A3656',
                        second_color: '#1A3656',
                        visuel_1: '',
                        visuel_1b: '',
                        visuel_2: '',
                        visuel_3: '',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#67C2EF',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'sebmore':
                    this.pdfConfig = {
                        societe: 'Invest More',
                        template: ['classique'],
                        logo_w: 1293,
                        logo_h: 173,
                        logo_url: 'assets/pdf/sebastienmore/sebastienmore.png',
                        logo_small_w: 174,
                        logo_small_h: 100,
                        logo_small_url: 'assets/sebastienmore-small.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: true,
                        display_contact: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: ``,
                        contact_bkg: '#538ED4',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#0C2446',
                        second_color: '#538ED4',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#538ED4',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#0C2446',
                        marque_blanche: false,
                    };
                    break;
                case 'invest_preneur':
                    this.pdfConfig = {
                        societe: 'JMC Liberté',
                        template: ['classique'],
                        logo_w: 469,
                        logo_h: 469,
                        logo_url: 'assets/pdf/invest_preneur/logo vignette avec shadow.png',
                        logo_small_w: 469,
                        logo_small_h: 469,
                        logo_small_url: 'assets/pdf/invest_preneur/logo vignette avec shadow.png',
                        logo_small_style: 'center',
                        display_legal_notice: false,
                        display_note: true,
                        display_contact: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: ``,
                        contact_bkg: '#1A3656',
                        h2_class: 'center',
                        h2_underline_url: '',
                        h3_class: 'center',
                        font_family: 'Rubik',
                        text_color: '#252525',
                        second_color: '#252525',
                        visuel_1: '',
                        visuel_1b: '',
                        visuel_2: '',
                        visuel_3: '',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#67C2EF',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'mci':
                    this.pdfConfig = {
                        societe: 'Mon Chasseur Immo',
                        template: ['classique', 'rendement'],
                        logo_w: 1024,
                        logo_h: 512,
                        logo_url: 'assets/pdf/mci/Mon chasseur immo.png',
                        logo_small_w: 830,
                        logo_small_h: 116,
                        logo_small_url: 'assets/pdf/mci/Logo-MCI-h.png',
                        logo_small_style: '',
                        display_legal_notice: true,
                        display_note: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Service client</b><br/>
                            Du lundi au vendredi de 9:00 à 19:00<br/>
                            Le samedi de 10:00 à 14:00<br/>
                            Tel : 01 88 32 03 40<br/>
                            www.monchasseurimmo.com`,
                        display_contact: true,
                        contact_bkg: '#00385E',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Gilroy',
                        text_color: '#00385E',
                        second_color: '#00385E',
                        visuel_1: 'assets/pdf/mci/analyse_secteur-1366x350.jpg',
                        visuel_1b: 'assets/pdf/mci/analyse_secteur-1366x350.jpg',
                        visuel_2: 'assets/pdf/mci/analyse-1366x350.jpg',
                        visuel_3: 'assets/pdf/mci/analyse-1366x350.jpg',
                        color_kpi_1: '#29BF8F',
                        color_kpi_2: '#FF3859',
                        color_kpi_3: '#00385E',
                        color_kpi_4: '#FFD154',
                        color_kpi_5: '#00385E',
                        marque_blanche: false,
                    };
                    break;
                case 'bienserein':
                    this.pdfConfig = {
                        societe: 'Bien serein',
                        template: ['classique'],
                        logo_w: 988,
                        logo_h: 466,
                        logo_url: 'assets/pdf/bienserein/bs positif plein horizontal.png',
                        logo_small_w: 988,
                        logo_small_h: 466,
                        logo_small_url: 'assets/pdf/bienserein/bs positif plein horizontal.png',
                        logo_small_style: '',
                        display_legal_notice: true,
                        display_note: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Contact</b><br/>
                            41 Avenue de la Paix<br/>
                            28300 Lèves<br/>
                            Tel : 02 37 22 12 30<br/>
                            www.bienserein.fr`,
                        display_contact: true,
                        contact_bkg: '#163B28',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Gilroy',
                        text_color: '#163B28',
                        second_color: '#163B28',
                        visuel_1: 'assets/pdf/bienserein/slide1.png',
                        visuel_1b: 'assets/pdf/bienserein/slide1.png',
                        visuel_2: 'assets/pdf/mci/analyse_secteur-1366x350.jpg',
                        visuel_3: 'assets/pdf/mci/analyse-1366x350.jpg',
                        color_kpi_1: '#163B28',
                        color_kpi_2: '#FF3859',
                        color_kpi_3: '#00385E',
                        color_kpi_4: '#EEC642',
                        color_kpi_5: '#00385E',
                        marque_blanche: false,
                    };
                    break;
                case 'regi-immo':
                    this.pdfConfig = {
                        societe: 'REGI investissement',
                        template: ['classique'],
                        logo_w: 720,
                        logo_h: 281,
                        logo_url: 'assets/pdf/regi-immo/logo.png',
                        logo_small_w: 720,
                        logo_small_h: 281,
                        logo_small_url: 'assets/pdf/regi-immo/logo.png',
                        logo_small_style: '',
                        display_legal_notice: true,
                        display_note: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Contact</b><br/>
                            32 RUE PIERRE PAUL RIQUET <br/>
                            31000 TOULOUSE <br/>
                            Tel : 06 18 73 47 73<br/>
                            www.regi-investissement.fr`,
                        display_contact: true,
                        contact_bkg: '#6D071C',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Gilroy',
                        text_color: '#000',
                        second_color: '#000',
                        visuel_1: 'assets/pdf/mci/analyse_secteur-1366x350.jpg',
                        visuel_1b: 'assets/pdf/mci/analyse_secteur-1366x350.jpg',
                        visuel_2: 'assets/pdf/mci/analyse_secteur-1366x350.jpg',
                        visuel_3: 'assets/pdf/mci/analyse-1366x350.jpg',
                        color_kpi_1: '#054E38',
                        color_kpi_2: '#6D071C',
                        color_kpi_3: '#762E08',
                        color_kpi_4: '#540545',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'cedric_berthelon':
                    this.pdfConfig = {
                        societe: 'Cédric Berthelon',
                        template: ['classique'],
                        logo_w: 464,
                        logo_h: 160,
                        logo_url: 'assets/pdf/cedric_berthelon/Logo.png',
                        logo_small_w: 100,
                        logo_small_h: 100,
                        logo_small_url: 'assets/pdf/cedric_berthelon/logo mini.png',
                        logo_small_style: 'center',
                        display_legal_notice: false,
                        display_note: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Votre contact</b><br/>
                            Cédric Berthelon<br/>
                            cedric@cedricberthelon.fr<br/>
                            06 50 79 86 96<br/>`,
                        display_contact: true,
                        contact_bkg: '#233160',
                        h2_class: 'center underline_img',
                        h2_underline_url: 'assets/pdf/cedric_berthelon/2_colors_line.png',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#212530',
                        second_color: '#212530',
                        visuel_1: 'assets/pdf/cedric_berthelon/Footer 1 Lybox.png',
                        visuel_1b: 'assets/pdf/cedric_berthelon/Footer 1 Lybox.png',
                        visuel_2: 'assets/pdf/cedric_berthelon/Footer 2 Lybox.png',
                        visuel_3: 'assets/pdf/cedric_berthelon/Footer 3 Lybox.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#67C2EF',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'eightcorp':
                    this.pdfConfig = {
                        societe: 'Cédric Berthelon',
                        template: ['classique'],
                        logo_w: 640,
                        logo_h: 194,
                        logo_url: 'assets/pdf/eightcorp/logo-Eight.png',
                        logo_small_w: 640,
                        logo_small_h: 194,
                        logo_small_url: 'assets/pdf/eightcorp/logo-Eight.png',
                        logo_small_style: 'center',
                        display_legal_notice: false,
                        display_note: false,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Votre contact</b><br/>
                            Cédric Berthelon<br/>
                            cedric@cedricberthelon.fr<br/>
                            06 50 79 86 96<br/>`,
                        display_contact: true,
                        contact_bkg: '#1D262F',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#1D262F',
                        second_color: '#2B51A3',
                        visuel_1: 'assets/pdf/eightcorp/Banniere.jpeg',
                        visuel_1b: 'assets/pdf/eightcorp/Banniere.jpeg',
                        visuel_2: 'assets/pdf/eightcorp/Banniere.jpeg',
                        visuel_3: 'assets/pdf/eightcorp/Banniere.jpeg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#67C2EF',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'smart_invest':
                    this.pdfConfig = {
                        societe: 'SMART investissement',
                        template: ['classique'],
                        logo_w: 1744,
                        logo_h: 600,
                        logo_url: 'assets/pdf/smart_investissement/LOGO-SMART.png',
                        logo_small_w: 1744,
                        logo_small_h: 600,
                        logo_small_url: 'assets/pdf/smart_investissement/LOGO-SMART.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Votre contact</b><br/>
                        SMART INVESTISSEMENT<br/>
                        13 Avenue de La Libération <br/>
                        Charles de Gaulle <br/>
                        33110 Le Bouscat <br/>`,
                        contact_bkg: '#1D839F',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#33373D',
                        second_color: '#33373D',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#67C2EF',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'jacquet_investissement':
                    this.pdfConfig = {
                        societe: 'Jacquet investissement',
                        template: ['classique'],
                        logo_w: 747,
                        logo_h: 251,
                        logo_url: 'assets/pdf/jacquet-investissement/logo-top.png',
                        logo_small_w: 2005,
                        logo_small_h: 306,
                        logo_small_url: 'assets/pdf/jacquet-investissement/jacquet-investissement.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Votre contact</b><br/>
                        Nicolas Jacquet<br/>
                        1, rue Darnet<br/>
                        87000 Limoges<br/>
                        06 50 02 58 29<br/>`,
                        contact_bkg: '#AA7942',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000000',
                        second_color: '#AA7942',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#67C2EF',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'perspective_patrimoine':
                    this.pdfConfig = {
                        societe: 'Perspective Patrimoine',
                        template: ['classique'],
                        logo_w: 3333,
                        logo_h: 2083,
                        logo_url: 'assets/pdf/perspective_patrimoine/logo-sans-accroche-1-.jpg',
                        logo_small_w: 3333,
                        logo_small_h: 2083,
                        logo_small_url: 'assets/pdf/perspective_patrimoine/logo-sans-accroche-1-.jpg',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'solo',
                        contact_visuel: 'assets/pdf/perspective_patrimoine/Yohan.png',
                        contact: `
                        <b>Yohan BOUREL</b><br/>
                        Consultant en stratégie fiscale<br/>
                        Perspective & Patrimoine<br/>
                        07.60.18.36.25<br/>
                        contact@perspectivepatrimoine.com<br/>`,
                        contact_bkg: '#2691D0',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000000',
                        second_color: '#A1D7F0',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'td_conseil':
                    this.pdfConfig = {
                        societe: 'TD Conseil',
                        template: ['classique'],
                        logo_w: 2000,
                        logo_h: 437,
                        logo_url: 'assets/pdf/td_conseil/td-conseils-logo-lineaire-sans-bord.png',
                        logo_small_w: 2000,
                        logo_small_h: 2000,
                        logo_small_url: 'assets/pdf/td_conseil/td-conseils-logo-carre-sans-baseline-plein.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'solo',
                        contact_visuel: 'assets/pdf/td_conseil/78374795_974912632907656_8868148361388097536_n-scaled-e1575923503181.jpg',
                        contact: `
                        <b>Delil Torgursul</b><br/>
                        Cabinet TD CONSEILS<br/>
                        15 rue Saint-Martin, 58000 Nevers<br/>
                        06 61 75 37 38<br/>
                        delil.torgursul@gmail.com<br/>`,
                        contact_bkg: '#ce1b28',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000000',
                        second_color: '#ce1b28',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'hevrest':
                    this.pdfConfig = {
                        societe: 'Hevrest',
                        template: ['classique'],
                        logo_w: 745,
                        logo_h: 335,
                        logo_url: 'assets/pdf/hevrest/hevrest-pdf.png',
                        logo_small_w: 750,
                        logo_small_h: 750,
                        logo_small_url: 'assets/pdf/hevrest/hevrest-small-pdf.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>Hevrest</b><br/>
                        www.hevrest.com<br/>
                        72 Rue Georges de Mestral<br/>74160 Archamps<br/>`,
                        contact_bkg: '#012D49',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Sentient',
                        text_color: '#012D49',
                        second_color: '#E0F1FF',
                        visuel_1: 'assets/pdf/hevrest/Geneve.png',
                        visuel_1b: 'assets/pdf/hevrest/Geneve.png',
                        visuel_2: 'assets/pdf/hevrest/Annecy.png',
                        visuel_3: 'assets/pdf/hevrest/Everest.png',
                        color_kpi_1: '#012D49',
                        color_kpi_2: '#0657A3',
                        color_kpi_3: '#0983E3',
                        color_kpi_4: '#82B1DC',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'projetlocatif':
                    this.pdfConfig = {
                        societe: 'Projet Locatif',
                        template: ['classique'],
                        logo_w: 300,
                        logo_h: 156,
                        logo_url: 'assets/pdf/projetlocatif/projet-locatif.png',
                        logo_small_w: 132,
                        logo_small_h: 132,
                        logo_small_url: 'assets/pdf/projetlocatif/logo-small.jpg',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>Projet Locatif</b><br/>
                        projetlocatif.fr<br/>
                        1025, avenue Henri-Becquerel<br/>
                        34 000 MONTPELLIER<br/>
                        téléphone : 04 67 82 19 40<br/>`,
                        contact_bkg: '#4C93C1',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#4C93C1',
                        second_color: '#4C93C1',
                        visuel_1: 'assets/pdf/projetlocatif/bkg1.png',
                        visuel_1b: 'assets/pdf/projetlocatif/bkg1.png',
                        visuel_2: 'assets/pdf/projetlocatif/bkg2.png',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'lesarchitectesdupatrimoine':
                    this.pdfConfig = {
                        societe: 'Les architectes du patrimoine',
                        template: ['classique'],
                        logo_w: 378,
                        logo_h: 200,
                        logo_url: 'assets/pdf/lesarchitectesdupatrimoine/lesarchitectesdupatrimoine.png',
                        logo_small_w: 80,
                        logo_small_h: 76,
                        logo_small_url: 'assets/pdf/lesarchitectesdupatrimoine/lesarchitectesdupatrimoine-small.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>Les architectes du patrimoine</b><br/>
                        lesarchitectesdupatrimoine.fr<br/>
                        14 rue de l'arcade<br/>
                        91540 Mennecy<br/>
                        téléphone : 06 88 98 83 30<br/>`,
                        contact_bkg: '#C7E6F4',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000',
                        second_color: '#C7E6F4',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'dakeys':
                    this.pdfConfig = {
                        societe: 'Dakey\'s immobilier',
                        template: ['classique'],
                        logo_w: 551,
                        logo_h: 607,
                        logo_url: 'assets/pdf/dakeys/dakeys.png',
                        logo_small_w: 573,
                        logo_small_h: 519,
                        logo_small_url: 'assets/pdf/dakeys/dakeys-small.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>Dakey's Immobilier</b><br/>
                        dakeys.fr<br/>
                        25 Bd Vauban<br/>
                        13006 Marseille<br/>
                        téléphone : 06 20 53 03 91<br/>`,
                        contact_bkg: '#17384C',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#044350',
                        second_color: '#9DBE43',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'cabinet-rostaing':
                    this.pdfConfig = {
                        societe: 'Cabinet rostaing',
                        template: ['classique'],
                        logo_w: 979,
                        logo_h: 925,
                        logo_url: 'assets/pdf/cabinet-rostaing/logo_rostaing.jpg',
                        logo_small_w: 979,
                        logo_small_h: 925,
                        logo_small_url: 'assets/pdf/cabinet-rostaing/logo_rostaing.jpg',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>Cabinet rostaing</b><br/>
                        cabinet-rostaing.com<br/>
                        1 Rue Fontaine l'Epine<br/>
                        25500 MORTEAU<br/>
                        téléphone : 03 81 67 54 34<br/>`,
                        contact_bkg: '#A71C24',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#111111',
                        second_color: '#A71C24',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'leducationfinanciere':
                    this.pdfConfig = {
                        societe: 'L\'Education Financière',
                        template: ['classique'],
                        logo_w: 979,
                        logo_h: 925,
                        logo_url: 'assets/pdf/leducationfinanciere/EF1.png',
                        logo_small_w: 979,
                        logo_small_h: 925,
                        logo_small_url: 'assets/pdf/leducationfinanciere/EF1.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'solo',
                        contact_visuel: 'assets/pdf/leducationfinanciere/leducationfinanciere.jpg',
                        contact: `
                        <b style="font-size: 22px;">Lamine Sylla</b><br/>
                        L\'Education Financière<br/>
                        <br/>
                        contact@leducationfinanciere.fr<br/>
                        téléphone : 07 60 27 54 92<br/>`,
                        contact_bkg: '#00C982',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#111111',
                        second_color: '#00C982',
                        visuel_1: 'assets/pdf/leducationfinanciere/pexels-essow-936722.jpg',
                        visuel_1b: 'assets/pdf/leducationfinanciere/pexels-geve-photo-5108878.jpg',
                        visuel_2: 'assets/pdf/leducationfinanciere/pexels-maria-orlova-4947281.jpg',
                        visuel_3: 'assets/pdf/leducationfinanciere/pexels-maria-orlova-4947281.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'naturellementriche':
                    this.pdfConfig = {
                        societe: 'Naturellement riche',
                        template: ['classique'],
                        logo_w: 702,
                        logo_h: 533,
                        logo_url: 'assets/pdf/naturellementriche/NR-immobilier-couleur.png',
                        logo_small_w: 702,
                        logo_small_h: 533,
                        logo_small_url: 'assets/pdf/naturellementriche/NR-immobilier-couleur.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>Naturellement Riche</b><br/>
                        naturellementriche.fr<br/>
                        96 Rue Louis Auguste Blanqui<br/>
                        93140 Bondy<br/>`,
                        contact_bkg: '#2a4e9d',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#29235C',
                        second_color: '#2a4e9d',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'learnimmo':
                    this.pdfConfig = {
                        societe: 'Learn Immo',
                        template: ['classique'],
                        logo_w: 693,
                        logo_h: 160,
                        logo_url: 'assets/pdf/learnimmo/learn-immo_logo_original-no-bg.png',
                        logo_small_w: 693,
                        logo_small_h: 160,
                        logo_small_url: 'assets/pdf/learnimmo/learn-immo_logo_original-no-bg.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>Learn Immo</b><br/>
                        learn-immo.fr<br/>
                        1 T AVENUE DES LEVADES<br/>
                        34470 PEROLS<br/>`,
                        contact_bkg: '#6EC1E4',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#010356',
                        second_color: '#6EC1E4',
                        visuel_1: 'assets/pdf/learnimmo/Image-1.jpg',
                        visuel_1b: 'assets/pdf/learnimmo/Image-2.jpg',
                        visuel_2: 'assets/pdf/learnimmo/Image-3.jpg',
                        visuel_3: 'assets/pdf/learnimmo/Image-3.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'baluchon':
                    this.pdfConfig = {
                        societe: 'Baluchon',
                        template: ['classique'],
                        logo_w: 1600,
                        logo_h: 526,
                        logo_url: 'assets/pdf/baluchon/Logo-rectangle.png',
                        logo_small_w: 1600,
                        logo_small_h: 526,
                        logo_small_url: 'assets/pdf/baluchon/Logo-rectangle.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `
                        <b>baluchon</b><br/>
                        www.baluchon.co<br/>
                        4, route des porrots<br/>
                        71400 ANTULLY<br/>`,
                        contact_bkg: '#464925',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#464925',
                        second_color: '#978149',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'valuo':
                    this.pdfConfig = {
                        societe: 'Valuo',
                        template: ['classique'],
                        logo_w: 1958,
                        logo_h: 796,
                        logo_url: 'assets/pdf/valuo/logo.png',
                        logo_small_w: 351,
                        logo_small_h: 323,
                        logo_small_url: 'assets/pdf/valuo/logo-small.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'solo',
                        contact_visuel: 'assets/pdf/valuo/solo.jpeg',
                        contact: `
                        <b>Antoine Gallet de Saint-Aurin </b><br/>
                        antoine@valuo.immo<br/>
                        229 boulevard Perreire, 75017 PARIS<br/>
                        <br/>
                        06 58 87 30 92`,
                        contact_bkg: '#194849',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#194849',
                        second_color: '#eca89e',
                        visuel_1: 'assets/pdf/valuo/valuo-1.jpg',
                        visuel_1b: 'assets/pdf/valuo/valuo-2.jpg',
                        visuel_2: 'assets/pdf/valuo/valuo-3.jpg',
                        visuel_3: 'assets/pdf/valuo/valuo-3.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'purpleimmobilier':
                    this.pdfConfig = {
                        societe: 'Purple immobilier',
                        template: ['classique'],
                        logo_w: 744,
                        logo_h: 748,
                        logo_url: 'assets/pdf/purpleimmobilier/LOGO purple.png',
                        logo_small_w: 500,
                        logo_small_h: 200,
                        logo_small_url: 'assets/pdf/purpleimmobilier/logo purple 2.png',
                        logo_small_style: '',
                        display_legal_notice: true,
                        display_note: false,
                        display_contact: true,
                        contact_tpl: 'solo',
                        contact_visuel: 'assets/pdf/purpleimmobilier/LOGO purple.png',
                        contact: `
                        <br/><br/><b>www.purpleimmobilier.fr</b><br/>
                        hello@purpleimmobilier.fr<br/>`,
                        contact_bkg: '#541B7D',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000',
                        second_color: '#4B137D',
                        visuel_1: 'assets/pdf/purpleimmobilier/purple_img.png',
                        visuel_1b: 'assets/pdf/purpleimmobilier/purple_img.png',
                        visuel_2: 'assets/pdf/purpleimmobilier/purple_img.png',
                        visuel_3: 'assets/pdf/purpleimmobilier/purple_img.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#2691D0',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        marque_blanche: false,
                    };
                    break;
                case 'investissement_locatif':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 2570,
                        logo_h: 990,
                        logo_url: 'assets/pdf/investissement_locatif/logo2.png',
                        logo_small_w: 2567,
                        logo_small_h: 539,
                        logo_small_url: 'assets/pdf/investissement_locatif/logo-investissement-locatif.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#030347',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Raleway',
                        text_color: '#1A1934',
                        second_color: '#04B6E8',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#030347',
                        color_kpi_2: '#1971D0',
                        color_kpi_3: '#04B6E8',
                        color_kpi_4: '#D3E7FF',
                        color_kpi_5: '#00889F',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Investissement locatif</b><br/>
                            117 rue auguste laurent<br/>
                            75011 Paris<br/>
                           www.investissement-locatif.com`,
                        marque_blanche: false,
                    };
                    break;
                case '110chasseimmobiliere':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 1000,
                        logo_h: 488,
                        logo_url: 'assets/pdf/110chasseimmobiliere/110-chasse-immobiliere.png',
                        logo_small_w: 866,
                        logo_small_h: 511,
                        logo_small_url: 'assets/pdf/110chasseimmobiliere/small_logo.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#013d45',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#013d45',
                        second_color: '#cae1e8',
                        visuel_1: 'assets/pdf/110chasseimmobiliere/Frame 1.png',
                        visuel_1b: 'assets/pdf/110chasseimmobiliere/Frame 2.png',
                        visuel_2: 'assets/pdf/110chasseimmobiliere/Frame 3.png',
                        visuel_3: 'assets/pdf/110chasseimmobiliere/Frame 4.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>110 Chasse immobilière</b><br/>
                            25 rue Simone Signoret<br/>
                            79390 Bois d’Arcy<br/>
                            110chasseimmobiliere.com`,
                        marque_blanche: false,
                    };
                    break;
                case 'wao':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 1252,
                        logo_h: 623,
                        logo_url: 'assets/pdf/wao/logo.png',
                        logo_small_w: 1252,
                        logo_small_h: 623,
                        logo_small_url: 'assets/pdf/wao/logo.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#000',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000',
                        second_color: '#fff',
                        visuel_1: 'assets/pdf/wao/Frame 1.png',
                        visuel_1b: 'assets/pdf/wao/Frame 2.png',
                        visuel_2: 'assets/pdf/wao/Frame 3.png',
                        visuel_3: 'assets/pdf/wao/Frame 1.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>WAO</b><br/>
                            8 rue de la justice<br/>
                            68100 MULHOUSE<br/>`,
                        marque_blanche: false,
                    };
                    break;
                case 'kgimmobilier':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 293,
                        logo_h: 177,
                        logo_url: 'assets/pdf/kgimmobilier/KG-Transaction.png',
                        logo_small_w: 293,
                        logo_small_h: 177,
                        logo_small_url: 'assets/pdf/kgimmobilier/KG-Transaction.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#c47b3a',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000',
                        second_color: '#c47b3a',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>KG IMMOBILIER</b><br/>
                            www.kgimmobilier.fr<br/>
                            6 RUE GILBERT<br/>
                            54000 Nancy<br/>`,
                        marque_blanche: false,
                    };
                    break;
                case 'courtage-locatif':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 1901,
                        logo_h: 602,
                        logo_url: 'assets/pdf/imonya/imonya.png',
                        logo_small_w: 1901,
                        logo_small_h: 602,
                        logo_small_url: 'assets/pdf/imonya/imonya.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#1B3B62',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#1B3B62',
                        second_color: '#2A6EC7',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Imonya</b><br/>
                            07 87 67 06 32<br/>
                            www.imonya.fr<br/>`,
                        marque_blanche: true,
                    };
                    break;
                // case 'investissement-locatif':
                //     this.pdfConfig = {
                //         societe: '',
                //         template: ['classique'],
                //         logo_w: 552,
                //         logo_h: 372,
                //         logo_url: 'assets/pdf/appartrouen/logo-2.resized.png',
                //         logo_small_w: 1390,
                //         logo_small_h: 326,
                //         logo_small_url: 'assets/pdf/appartrouen/logo-1.resized.png',
                //         logo_small_style: '',
                //         display_legal_notice: false,
                //         display_note: false,
                //         display_contact: true,
                //         contact_bkg: '#04B6E8',
                //         h2_class: 'underline',
                //         h2_underline_url: '',
                //         h3_class: '',
                //         font_family: 'Rubik',
                //         text_color: '#0C0B37',
                //         second_color: '#04B6E8',
                //         visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                //         visuel_1b: 'assets/pdf/template/quartier.jpg',
                //         visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                //         visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                //         color_kpi_1: '#030374',
                //         color_kpi_2: '#1971D0',
                //         color_kpi_3: '#04B6E8',
                //         color_kpi_4: '#D3E7FF',
                //         color_kpi_5: '#00889F',
                //         contact_tpl: 'solo',
                //         contact_visuel: '',
                //         contact: `<b>Guillaume HUYS</b><br/><br/>
                //             Chasseur immobilier Rouen<br/>
                //             06 52 57 84 26<br/><br/>`,
                //         marque_blanche: true,
                //     };
                //     break;
                case 'pileapartners':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 816,
                        logo_h: 820,
                        logo_url: 'assets/pdf/pileapartners/pileapartners.png',
                        logo_small_w: 312,
                        logo_small_h: 100,
                        logo_small_url: 'assets/pdf/pileapartners/pileapartners-small.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#0B5345',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#000000',
                        second_color: '#B7950B',
                        visuel_1: 'assets/pdf/pileapartners/Frame 1.png',
                        visuel_1b: 'assets/pdf/pileapartners/Frame 2.png',
                        visuel_2: 'assets/pdf/pileapartners/Frame 3.png',
                        visuel_3: 'assets/pdf/pileapartners/Frame 4.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>PILEA PARTNERS</b><br/>
                            5 Rue FÉNÉLON<br/>
                            33000 BORDEAUX`,
                        marque_blanche: false,
                    };
                    break;
                case 'greginvest':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 902,
                        logo_h: 358,
                        logo_url: 'assets/pdf/greginvest/Logo-GregINVEST-PNG-SANS-FOND.png',
                        logo_small_w: 902,
                        logo_small_h: 358,
                        logo_small_url: 'assets/pdf/greginvest/Logo-GregINVEST-PNG-SANS-FOND.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#5c86ad',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#3A3A3A',
                        second_color: '#5c86ad',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Greg Invest</b><br/>
                            48 Rue George Clemenceau<br/>
                            25200 Monbtbéliard<br/>
                            www.greginvest.com`,
                        marque_blanche: false,
                    };
                    break;
                case 'minuta':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 723,
                        logo_h: 699,
                        logo_url: 'assets/pdf/minuta/minuta.png',
                        logo_small_w: 1919,
                        logo_small_h: 464,
                        logo_small_url: 'assets/pdf/minuta/minuta-2.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#195880',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#195880',
                        second_color: '#2fac66',
                        visuel_1: 'assets/pdf/minuta/Frame 1.png',
                        visuel_1b: 'assets/pdf/minuta/Frame 2.png',
                        visuel_2: 'assets/pdf/minuta/Frame 3.png',
                        visuel_3: 'assets/pdf/minuta/Frame 4.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'solo',
                        contact_visuel: 'assets/pdf/minuta/photo.png',
                        contact: `<b>MINUTA</b><br/>
                            <br/>
                            Eléonore BRANCHY<br/>
                            06 21 71 01 86<br/>
                            <br/>
                            www.minuta.fr<br/>`,
                        marque_blanche: false,
                    };
                    break;
                case 'so7':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 446,
                        logo_h: 323,
                        logo_url: 'assets/pdf/so7/logo.png',
                        logo_small_w: 446,
                        logo_small_h: 323,
                        logo_small_url: 'assets/pdf/so7/logo.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#776116',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#776116',
                        second_color: '#fff087',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>SAS DYNASTY-SO7</b><br/>
                            4 rue de la république, 69001 LYON<br/>
                            06 38 18 14 89<br/>
                            dynasty-so7.fr<br/>`,
                        marque_blanche: false,
                    };
                    break;
                case 'invisty':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 5732,
                        logo_h: 1887,
                        logo_url: 'assets/pdf/invisty/Logo.png',
                        logo_small_w: 5732,
                        logo_small_h: 1887,
                        logo_small_url: 'assets/pdf/invisty/Logo.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#2C9DD9',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#2C9DD9',
                        second_color: '#EDEAE7',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Invisty</b><br/>
                            10 place marechal lyautey<br/>
                            69006 Lyon<br/>
                            https://invisty.com<br/>`,
                        marque_blanche: false,
                    };
                    break;
                case 'skelo':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 595,
                        logo_h: 245,
                        logo_url: 'assets/pdf/skelo/logo.png',
                        logo_small_w: 595,
                        logo_small_h: 245,
                        logo_small_url: 'assets/pdf/skelo/logo.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#240D03',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#240D03',
                        second_color: '#D9D6D1',
                        visuel_1: 'assets/pdf/skelo/Frame 1.png',
                        visuel_1b: 'assets/pdf/skelo/Frame 2.png',
                        visuel_2: 'assets/pdf/skelo/Frame 3.png',
                        visuel_3: 'assets/pdf/skelo/Frame 3.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'solo',
                        contact_visuel: '',
                        contact: `<b>Skelo immobilier</b><br/>
                            contact@skelo.fr<br/>
                            6 rue d'armaillé <br/>
                            75017 Paris<br/>
                            https://skelo.fr/<br/>`,
                        marque_blanche: false,
                    };
                    break;
                case 'cg2i':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 780,
                        logo_h: 632,
                        logo_url: 'assets/pdf/cg2i/logo-neutre-CG2I.png',
                        logo_small_w: 780,
                        logo_small_h: 632,
                        logo_small_url: 'assets/pdf/cg2i/logo-neutre-CG2I.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#0B2244',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#232323',
                        second_color: '#0B2244',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'solo',
                        contact_visuel: '',
                        contact: `<b>CG2I</b><br/>
                            Matthias Denis<br/><br/>
                            matthias.denis88@gmail.com<br/>
                            07 66 55 96 87<br/>`,
                        marque_blanche: false,
                    };
                    break;

                case 'immopourexpat':
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique'],
                        logo_w: 815,
                        logo_h: 743,
                        logo_url: 'assets/pdf/immopourexpat/LOGO-IPE3.png',
                        logo_small_w: 1758,
                        logo_small_h: 412,
                        logo_small_url: 'assets/pdf/immopourexpat/LOGO-IPE6.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#006dff',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#2D2E48',
                        second_color: '#006dff',
                        visuel_1: 'assets/pdf/immopourexpat/Frame 1.png',
                        visuel_1b: 'assets/pdf/immopourexpat/Frame 2.png',
                        visuel_2: 'assets/pdf/immopourexpat/Frame 3.png',
                        visuel_3: 'assets/pdf/immopourexpat/Frame 3.png',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#EA5044',
                        color_kpi_3: '#19B7E9',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>IMMO POUR EXPAT'</b><br/>
                            8a rue du puits<br/>
                            L-2355 Luxembourg<br/><br/>
                            www.immopourexpat.com`,
                        marque_blanche: false,
                    };
                    break;

                default:
                    this.pdfConfig = {
                        societe: '',
                        template: ['classique', 'rendement'],
                        logo_w: 1170,
                        logo_h: 608,
                        logo_url: 'assets/pdf/template/logo_ici_main_blue_dark.png',
                        logo_small_w: 1338,
                        logo_small_h: 370,
                        logo_small_url: 'assets/pdf/template/logo_ici_sec_blue_dark.png',
                        logo_small_style: '',
                        display_legal_notice: false,
                        display_note: false,
                        display_contact: true,
                        contact_bkg: '#1A3656',
                        h2_class: 'underline',
                        h2_underline_url: '',
                        h3_class: '',
                        font_family: 'Rubik',
                        text_color: '#1A3656',
                        second_color: '#1A3656',
                        visuel_1: 'assets/pdf/template/street-5932230_1920.jpg',
                        visuel_1b: 'assets/pdf/template/quartier.jpg',
                        visuel_2: 'assets/pdf/template/financial-2860753_1920.jpg',
                        visuel_3: 'assets/pdf/template/financial-2860753_1920.jpg',
                        color_kpi_1: '#79C447',
                        color_kpi_2: '#FF5455',
                        color_kpi_3: '#67C2EF',
                        color_kpi_4: '#FABB3D',
                        color_kpi_5: '#1277AA',
                        contact_tpl: 'agence',
                        contact_visuel: '',
                        contact: `<b>Votre agence</b><br/>
                            181 Av. des Champs-Élysées<br/>
                            Tel : 01 02 03 04 05<br/>
                            www.lybox.fr`,
                        marque_blanche: false,
                    };
                    break;
            }
            let css = `
                #book .page * {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book .page textarea {
                    color: #343a40;
                }
                #book .page .bilan_comptable td  {
                    font-family: 'arial';
                }
                #book .page .contact * {
                    color: white;
                }
                #book .page .text-blue-dark, #book .text-blue {
                    color: ` + this.pdfConfig.text_color + ` !important;
                }
                #book .page .title input {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book .page h2 {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                }
                #book .page .card .card-header .card-title h3 {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                }
                #book .page .block.card label {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .page .block_recap table td {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .page .block_recap table th, #book .block_recap table th > div, #book .block_recap table th > div > span {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .page .desc, #book .desc textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .page .notes, #book .notes textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .page .contact {
                    background-color: ` + this.pdfConfig.contact_bkg + `;
                }
                #book .page .contact .col-md-6 {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .page .contact .col-md-6 b {
                    font-family: "` + this.pdfConfig.font_family + `-SemiBold";
                }
                #book .page h2.underline::after {
                    border-color: ` + this.pdfConfig.second_color + ` !important;
                }
                #book .page .kpi-color-1 {
                    background-color: ` + this.pdfConfig.color_kpi_1 + `;
                }
                #book .page .kpi-color-2 {
                    background-color: ` + this.pdfConfig.color_kpi_2 + `;
                }
                #book .page .kpi-color-3 {
                    background-color: ` + this.pdfConfig.color_kpi_3 + `;
                }
                #book .page .kpi-color-4 {
                    background-color: ` + this.pdfConfig.color_kpi_4 + `;
                }
                #book .page .kpi-color-5 {
                    background-color: ` + this.pdfConfig.color_kpi_5 + `;
                }
            `;

            if (params.config == 'lesarchitectesdupatrimoine') {
                css += `.contact .col-md-6, .contact .col-md-6 b {
                    color: ` + this.pdfConfig.text_color + ` !important;
                }`;
            }
            if (params.config == 'purpleimmobilier') {
                css += `.contact_visuel {
                    border-radius: 0 !important;
                }
                .contact {
                    padding-top: 50px !important;
                }
                .bottom_img {
                    height: auto !important;
                }
                .bottom_link {
                    margin-top: 185px !important;
                }`;
            }

            const head = document.getElementsByTagName('head')[0];
            const style = document.createElement('style');
            style.type = 'text/css';
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);
        });

        this.user = this.authenticationService.currentUser;
        if (this.user.pro_plan !== '') {
            if (this.user.pro_data === '') {
                if (this.user.pro_plan == 'mci') {
                    this.alertService.error('Veuillez renseigner les informations de votre agences dans la partie "Mon compte"');
                }
            } else {
                this.pro_data = JSON.parse(this.user.pro_data);
            }
        }

        const available_page = ['annonce', 'secteur', 'secteur_bis', 'analyse', 'work', 'finance', 'patrimoniale', 'fiscal'];
        if (this.user.user_dashboard.pdf_profil == '') {
            this.user.user_dashboard.pdf_profil = 'classique';
            this.user.user_dashboard.pdf_quality = 'normal';
            this.user.user_dashboard.pdf_page = available_page;
        } else {
            let page = [];
            this.user.user_dashboard.pdf_page.forEach(keys => {
                if (available_page.includes(keys)) {
                    page.push(keys);
                }
            });
            this.user.user_dashboard.pdf_page = page;
        }

        this.route.parent.params.subscribe(params => {
            this.params = params;

            let id = params.favoriteId;
            if (this.router.url.includes('/app/annonces/')) {
                id = params.id;
            }

            this.adService.getFavorite(id).subscribe(result => {
                this.favorite = this.adService.updateValues(result);

                this.setRentData(this.favorite.furnish);
                this.setPriceData(this.favorite.estate_type);
                this.setPriceEvolData();
                this.setChargeData();
                this.setPopData();
                this.setShopData();
                this.setSchoolData();
                this.callImpot();

                if (this.favorite.ad.real_estate_type == 'immeuble' || this.favorite.nb_lots > 1 || this.favorite.lots.length > 1) {
                    let lot = this.favorite.lots.length;
                    if (this.favorite.nb_lots >= this.favorite.lots.length) {
                        lot = this.favorite.nb_lots;
                    }
                    this.title = 'Immeuble de ' + lot + '  lots | ' + this.favorite.ad_city.name;
                } else {
                    this.title = this.favorite.estate_type + ' ' + this.favorite.rooms + ' pièces | ' + this.favorite.ad_city.name;
                }

                this.favorite.description = this.favorite.description.replace(/<[^>]*>/g, '');
                this.advice_price = this.favorite.advice_price;
            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Favoris introuvable', true);
                    this.router.navigate(['/app/favorites', params.id]);
                }
            });
        });
    }

    createPdf() {
        if (!this.authenticationService.isAllowed('expert') || this.authenticationService.currentUser.plan == 'trial') {

            this.trackingService.click('pdf_upgrade_open', '');
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/export_1.png', plan: 'Expert', feature: 'Dossier bancaire'}
            });
            this.authenticationService.currentUser.user_onboarding.popup_search_fav = true;
            this.userService.updateOnboarding(this.authenticationService.currentUser);

            dialogRef.afterClosed().subscribe(result => {
                if (result === true) {
                    this.trackingService.click('pdf_upgrade_valid', '');
                } else {
                    this.trackingService.click('pdf_upgrade_cancel', '');
                }
            });
            return;
        }
        this.loading = true;

        function filter(node) {
            return (node.className !== 'logo' && node.className !== 'fontChange');
        }

        var scale = 1;
        if (this.user.user_dashboard.pdf_quality == 'hd') {
            scale = 2;
        }
        var offsetWidth = 1339.38;
        var offsetHeight = 1894.2525;

        if (this.user.user_dashboard.pdf_page.includes('annonce')) {
            htmlToImage.toPng(document.getElementById('annonce') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgAnnonce = dataUrl;
                    this.imgDone.push('annonce');
                    // window.open(dataUrl, '_blank');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('secteur')) {
            htmlToImage.toPng(document.getElementById('secteur') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgSecteur = dataUrl;
                    this.imgDone.push('secteur');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('secteur_bis')) {
            htmlToImage.toPng(document.getElementById('secteur_bis') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgSecteurBis = dataUrl;
                    this.imgDone.push('secteur_bis');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('analyse')) {
            if (this.favorite.lots.length <= 1) {
                this.imgAnalyse = "";
                this.imgDone.push('analyse');
                this.downloadPdf();
            } else {
                htmlToImage.toPng(document.getElementById('analyse') as HTMLElement, {
                    filter,
                    quality: 1.0,
                    pixelRatio: 1,
                    width: offsetWidth * scale,
                    height: offsetHeight * scale,
                    style: {
                        transform: 'scale(' + scale + ')',
                        transformOrigin: 'top left',
                        width: offsetWidth + 'px',
                        height: offsetHeight + 'px'
                    }
                })
                    .then(dataUrl => {
                        this.imgAnalyse = dataUrl;
                        this.imgDone.push('analyse');
                        this.downloadPdf();
                    });
            }
        }

        if (this.user.user_dashboard.pdf_page.includes('work')) {
            if (this.favorite.lots.length <= 1) {
                this.imgWork = "";
                this.imgDone.push('work');
                this.downloadPdf();
            } else {
                htmlToImage.toPng(document.getElementById('work') as HTMLElement, {
                    filter,
                    quality: 1.0,
                    pixelRatio: 1,
                    width: offsetWidth * scale,
                    height: offsetHeight * scale,
                    style: {
                        transform: 'scale(' + scale + ')',
                        transformOrigin: 'top left',
                        width: offsetWidth + 'px',
                        height: offsetHeight + 'px'
                    }
                })
                    .then(dataUrl => {
                        this.imgWork = dataUrl;
                        this.imgDone.push('work');
                        this.downloadPdf();
                    });
            }
        }

        if (this.user.user_dashboard.pdf_page.includes('finance')) {
            htmlToImage.toPng(document.getElementById('finance') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance = dataUrl;
                    this.imgDone.push('finance');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('patrimoniale')) {
            htmlToImage.toPng(document.getElementById('patrimoniale') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPatrimoniale = dataUrl;
                    this.imgDone.push('patrimoniale');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('fiscal')) {
            htmlToImage.toPng(document.getElementById('fiscal') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFiscal = dataUrl;
                    this.imgDone.push('fiscal');
                    this.downloadPdf();
                });
        }
    }

    downloadPdf() {
        if (this.imgDone.length == this.user.user_dashboard.pdf_page.length) {

            const pdf = new jsPDF('p', 'px', 'a4');

            const width = pdf.internal.pageSize.getWidth();
            const height = pdf.internal.pageSize.getHeight();

            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('Gilroy-SemiBold');

            if (this.user.user_dashboard.pdf_page.includes('annonce')) {
                pdf.addPage();
                pdf.addImage(this.imgAnnonce, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                let height_logo = Math.round(this.pdfConfig.logo_h / 3);
                if (height_logo > 80) {
                    height_logo = 80;
                }
                const with_logo = this.pdfConfig.logo_w / (this.pdfConfig.logo_h / height_logo);
                pdf.addImage(this.pdfConfig.logo_url, 'PNG', (width - with_logo) / 2, 25, with_logo, height_logo);
            }

            // Title (dont take user modification)
            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('' + this.pdfConfig.font_family + '-SemiBold');
            pdf.setTextColor(this.pdfConfig.text_color);
            pdf.setFontSize(8);
            // pdf.setFontSize(22);
            // pdf.text(this.favorite.estate_type + ' | ' + this.favorite.rooms + ' pièces | ' + this.favorite.square + 'm2', 220, 150, {align: 'center'});

            const height_small_logo = 20;
            const with_small_logo = this.pdfConfig.logo_small_w / (this.pdfConfig.logo_small_h / height_small_logo);
            let x = 20;
            if (this.pdfConfig.logo_small_style.includes('center')) {
                x = (width - with_small_logo) / 2;
            }

            if (this.user.user_dashboard.pdf_page.includes('secteur')) {
                pdf.addPage();
                pdf.addImage(this.imgSecteur, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('secteur_bis')) {
                pdf.addPage();
                pdf.addImage(this.imgSecteurBis, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('analyse') && this.favorite.lots.length > 1) {
                pdf.addPage();
                pdf.addImage(this.imgAnalyse, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('work') && this.favorite.lots.length > 1) {
                pdf.addPage();
                pdf.addImage(this.imgWork, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('finance')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('patrimoniale')) {
                pdf.addPage();
                pdf.addImage(this.imgPatrimoniale, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('fiscal')) {
                pdf.addPage();
                pdf.addImage(this.imgFiscal, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', x, 20, with_small_logo, height_small_logo);
            }
            pdf.deletePage(1);
            pdf.save(this.favorite.title + '.pdf');

            // Save export date
            this.http.put(`${environment.apiUrl}app/favorite/${this.favorite.id}/export`, {}).subscribe(result => {
                this.alertService.success('Export terminé');
            }, error => {
                console.log(error);
            });
            this.imgAnnonce = '';
            this.imgSecteur = '';
            this.imgFinance = '';
            this.imgPatrimoniale = '';
            this.imgFiscal = '';
            this.imgDone = [];
            this.loading = false;
        }
    }

    setRentData(furnish) {
        this.rentOptions.yAxis.data = ['1 pièces / Studio', '2 pièces', '3 pièces', '4 pièces', '5 pièces', 'Appartement', 'Maison', 'Garage / Parking'];

        this.rentOptions.xAxis.max = Math.round([
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville.A.lM,
            this.favorite.ad_city.loyer_moyen_ville.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_meuble.A.lM,
            this.favorite.ad_city.loyer_moyen_ville_meuble.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_non_meuble.A.lM,
            this.favorite.ad_city.loyer_moyen_ville_non_meuble.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
        ].sort((a, b) => b - a)[0] / 1);

        if (furnish === 0) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        } else if (furnish === 1) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_meuble.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville_meuble.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        } else if (furnish === 2) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_non_meuble.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville_non_meuble.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        }

        if (this.favorite.id !== '') {
            this.rentOptions.yAxis.data.push('Votre projet');
            this.rentData.series.push(
                {
                    name: 'Votre projet',
                    type: 'bar',
                    stack: '1',
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0, // One more for the city below
                        this.favorite.square > 0 ? (this.favorite.amount_rent / this.favorite.square).toPrecision(3) : 0,
                    ]
                });
        }

        if (this.favorite.ad_city.loyer_moyen_ville.A.lM > 0 || this.favorite.ad_city.loyer_moyen_ville.M.lM > 0) {
            this.rentOptions.yAxis.data = [this.favorite.ad_city.name].concat(this.rentOptions.yAxis.data);
            this.rentData.series[0].data = [this.favorite.ad_city.loyer_moyen_petite_ville.lM.toPrecision(3)].concat(this.rentData.series[0].data);
        } else {
            this.rentOptions.yAxis.data = [this.favorite.ad_city.zip_code].concat(this.rentOptions.yAxis.data);
            this.rentData.series[0].data = [this.favorite.ad_city.loyer_moyen_petite_ville_cp.lM].concat(this.rentData.series[0].data);
        }

        if (this.rentEchartsIntance) {
            this.rentEchartsIntance.setOption(this.rentOptions);
        }
    }

    setPriceData(estateType) {
        this.priceOptions.yAxis.data = ['1 pièces / Studio', '2 pièces', '3 pièces', '4 pièces', '5 pièces', 'Appartement', 'Maison'];

        this.priceOptions.xAxis.max = Math.round([
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[1] ? this.favorite.ad_city.prix_commune_nb_piece.A[1].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[2] ? this.favorite.ad_city.prix_commune_nb_piece.A[2].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[3] ? this.favorite.ad_city.prix_commune_nb_piece.A[3].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[4] ? this.favorite.ad_city.prix_commune_nb_piece.A[4].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[5] ? this.favorite.ad_city.prix_commune_nb_piece.A[5].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[1] ? this.favorite.ad_city.prix_commune_nb_piece.M[1].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[2] ? this.favorite.ad_city.prix_commune_nb_piece.M[2].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[3] ? this.favorite.ad_city.prix_commune_nb_piece.M[3].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[4] ? this.favorite.ad_city.prix_commune_nb_piece.M[4].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[5] ? this.favorite.ad_city.prix_commune_nb_piece.M[5].pM : 0,
            this.favorite.total_price / this.favorite.square
        ].sort((a, b) => b - a)[0] / 1);

        if (estateType === 'Maison') {
            this.priceData = {
                series: [
                    {
                        name: 'Maison',
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[1] ? this.favorite.ad_city.prix_commune_nb_piece.M[1].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[2] ? this.favorite.ad_city.prix_commune_nb_piece.M[2].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[3] ? this.favorite.ad_city.prix_commune_nb_piece.M[3].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[4] ? this.favorite.ad_city.prix_commune_nb_piece.M[4].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[5] ? this.favorite.ad_city.prix_commune_nb_piece.M[5].pM : null,
                            this.favorite.ad_city.prix_commune.A.pM,
                            this.favorite.ad_city.prix_commune.M.pM,
                        ]
                    }
                ]
            };

            this.priceOptions.yAxis.data = [this.favorite.ad_city.zip_code].concat(this.priceOptions.yAxis.data);
            this.priceData.series[0].data = [this.favorite.ad_city.prix_commune.B.pM.toPrecision(3)].concat(this.priceData.series[0].data);
        } else {
            this.priceData = {
                series: [
                    {
                        name: 'Appartement',
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[1] ? this.favorite.ad_city.prix_commune_nb_piece.A[1].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[2] ? this.favorite.ad_city.prix_commune_nb_piece.A[2].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[3] ? this.favorite.ad_city.prix_commune_nb_piece.A[3].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[4] ? this.favorite.ad_city.prix_commune_nb_piece.A[4].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[5] ? this.favorite.ad_city.prix_commune_nb_piece.A[5].pM : null,
                            this.favorite.ad_city.prix_commune.A.pM,
                            this.favorite.ad_city.prix_commune.M.pM,
                        ]
                    },
                ]
            };

            this.priceOptions.yAxis.data = [this.favorite.ad_city.name].concat(this.priceOptions.yAxis.data);
            this.priceData.series[0].data = [this.favorite.ad_city.prix_commune.B.pM.toPrecision(3)].concat(this.priceData.series[0].data);
        }

        this.priceOptions.yAxis.data.push('Votre projet');
        this.priceData.series.push(
            {
                name: 'Votre projet',
                type: 'bar',
                stack: '1',
                data: [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0, // One more for the city
                    (this.favorite.total_price / this.favorite.square).toPrecision(4),
                ]
            });

        if (this.priceEchartsIntance) {
            this.priceEchartsIntance.setOption(this.priceOptions);
        }
    }

    setPriceEvolData() {

        if (this.favorite.ad_city.city_code === '') {
            return;
        }
        const dataAdep = [];
        const dataMdep = [];
        const dataAville = [];
        const dataMville = [];

        this.priceEvolOptions.xAxis.data = PRICE_EVOL_LEGENT;
        this.priceEvolOptions.xAxis.data.forEach(keys => {

            if (this.favorite.ad_city.prix_departement.A != null && this.favorite.ad_city.prix_departement.A[keys] !== undefined) {
                dataAdep.push(this.favorite.ad_city.prix_departement.A[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_departement.A[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAdep.push('');
            }

            if (this.favorite.ad_city.prix_departement.M != null && this.favorite.ad_city.prix_departement.M[keys] !== undefined) {
                dataMdep.push(this.favorite.ad_city.prix_departement.M[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_departement.M[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMdep.push('');
            }

            if (this.favorite.ad_city.prix_ville.A != null && this.favorite.ad_city.prix_ville.A[keys] !== undefined) {
                dataAville.push(this.favorite.ad_city.prix_ville.A[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.A[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAville.push('');
            }

            if (this.favorite.ad_city.prix_ville.M != null && this.favorite.ad_city.prix_ville.M[keys] !== undefined) {
                dataMville.push(this.favorite.ad_city.prix_ville.M[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.M[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMville.push('');
            }
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.departement + ' : Appartement',
            type: 'line',
            data: dataAdep
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.departement + ' : Maison',
            type: 'line',
            data: dataMdep
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Appartement',
            type: 'line',
            data: dataAville
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Maison',
            type: 'line',
            data: dataMville
        });

        this.priceEvolOptions.legend.selected = {
            [this.favorite.ad_city.departement + ' : Appartement']: dataAville.filter(Boolean).length < 1,
            [this.favorite.ad_city.departement + ' : Maison']: dataMville.filter(Boolean).length < 1,
            [this.favorite.ad_city.name + ' : Appartement']: dataAville.filter(Boolean).length >= 1,
            [this.favorite.ad_city.name + ' : Maison']: dataMville.filter(Boolean).length >= 1,
        };
    }

    setChargeData() {
        let data = {
            series: [
                {
                    right: '20%',
                    name: '',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    avoidLabelOverlap: false,
                    fontSize: 30,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    data: []
                }
            ]
        };

        if (this.favorite.monthly > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.monthly), name: 'Mensualité'});
        }
        if (this.favorite.amount_property_tax > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_property_tax / 12), name: 'Taxe foncière'});
        }
        if (this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) / 100), name: 'Gestion en agence'});
        }
        if (this.favorite.amount_copro > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_copro / 12), name: 'Charges de copro'});
        }
        if (this.favorite.amount_rent_insurance > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_rent_insurance * this.favorite.amount_rent / 100), name: 'GLI'});
        }
        if (this.favorite.building_insurance > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.building_insurance / 12), name: 'Assurance PNO'});
        }
        if (this.favorite.cash_flow > 0) {
            data.series[0].data.push({value: Math.round((this.favorite.cash_flow > 0) ? this.favorite.cash_flow : 0), name: 'Cash flow'});
        }

        this.chargeData = data;

        if (this.favorite.other_bill > 0) {
            this.chargeData.series[0].data.push({value: Math.round(this.favorite.other_bill / 12), name: 'Autres frais'});
        }
        if (this.favorite.accouting_fees + this.favorite.cfe_contribution + this.favorite.cga_contribution > 0) {
            this.chargeData.series[0].data.push({value: Math.round((this.favorite.accouting_fees + this.favorite.cfe_contribution + this.favorite.cga_contribution) / 12), name: 'Frais de comptabilités'});
        }
    }

    setPopData() {

        this.popOptions.yAxis.min = 1000000;
        this.popOptions.xAxis.data = [];

        const dataPop = [];
        Object.keys(this.favorite.ad_city.demographie_annuelle).forEach(keys => {
            if (keys !== 'Cr') {
                dataPop.push(this.favorite.ad_city.demographie_annuelle[keys]);
                this.popOptions.xAxis.data.push(keys);
                if (this.popOptions.yAxis.min > (this.favorite.ad_city.demographie_annuelle[keys] * 0.9)) {
                    this.popOptions.yAxis.min = Math.round(this.favorite.ad_city.demographie_annuelle[keys] * 0.9 / 1000 - 1) * 1000;
                }
            }
        });
        this.popData = {
            series: [
                {
                    name: this.favorite.ad_city.name,
                    type: 'bar',
                    data: dataPop,
                },
            ]
        };

        if (this.popEchartsIntance) {
            this.popEchartsIntance.setOption(this.popOptions);
        }
    }

    setShopData() {
        this.shopData = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    center: ['280', '50%'],
                    radius: ['55%', '80%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'inner',
                    },
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#9C9C9C', '#FF5455'],

                    data: [
                        {value: Math.round(this.favorite.ad_city.commerce.hypmar + this.favorite.ad_city.commerce.supmar + this.favorite.ad_city.commerce.surge), name: 'Grande distribution'},
                        {value: Math.round(this.favorite.ad_city.commerce.opt + this.favorite.ad_city.commerce.medi + this.favorite.ad_city.commerce.pharma), name: 'Santé'},
                        {value: Math.round(this.favorite.ad_city.commerce.sport + this.favorite.ad_city.commerce.vet + this.favorite.ad_city.commerce.chaus), name: 'Shopping'},
                        {
                            value: Math.round(this.favorite.ad_city.commerce.boulan + this.favorite.ad_city.commerce.epice + this.favorite.ad_city.commerce.poisson +
                                this.favorite.ad_city.commerce.supe + this.favorite.ad_city.commerce.bouch), name: 'Commerces de proximité'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.commerce.brico + this.favorite.ad_city.commerce.droguerie + this.favorite.ad_city.commerce.electro
                                + this.favorite.ad_city.commerce.equ + this.favorite.ad_city.commerce.revet + this.favorite.ad_city.commerce.meub), name: 'Magasins pour la maison'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.commerce.essence + this.favorite.ad_city.commerce.fleur + this.favorite.ad_city.commerce.horlog
                                + this.favorite.ad_city.commerce.lib + this.favorite.ad_city.commerce.parfum), name: 'Autres'
                        },
                    ],
                },
            ]
        };
    }

    setSchoolData() {
        this.schoolData = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    center: ['280', '50%'],
                    radius: ['55%', '80%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'inner',
                    },
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#FF5455'],

                    data: [
                        {
                            value: Math.round(this.favorite.ad_city.ecole.maternelle + this.favorite.ad_city.ecole.elementaire + this.favorite.ad_city.ecole.college),
                            name: 'Enfance'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.ecole.lycee_gen_techno + this.favorite.ad_city.ecole.lycee_pro + this.favorite.ad_city.ecole.lycee_techniqe_etou_pro_agricole),
                            name: 'Lycée'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.ecole.cpge + this.favorite.ad_city.ecole.ecole_inge + this.favorite.ad_city.ecole.institut_universitaire
                                + this.favorite.ad_city.ecole.enseign_general_sup_prive + this.favorite.ad_city.ecole.enseign_sup_agricole + this.favorite.ad_city.ecole.unite_de_form_et_recherche
                                + this.favorite.ad_city.ecole.autre_enseign_sup + this.favorite.ad_city.ecole.autre_postbac),
                            name: 'Enseignement supérieur'
                        },
                        {
                            value: Math.round(this.favorite.ad_city.ecole.centre_form_agricole + this.favorite.ad_city.ecole.centre_form_apprentis + this.favorite.ad_city.ecole.form_apprentissage_agricole
                                + this.favorite.ad_city.ecole.form_commerce + this.favorite.ad_city.ecole.form_sante + this.favorite.ad_city.ecole.form_sport
                                + this.favorite.ad_city.ecole.greta + this.favorite.ad_city.ecole.autre_form_continu), name: 'Formations'
                        }
                    ],
                },
            ]
        };
    }

    callImpot() {

        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);

        const fav = this.adService.cleanForImpot(this.favorite, this.user);

        if (fav.fiscal_choice !== '' && fav.price > 0 && fav.amount_rent > 0) {
            fav.is_credit_differed = false;
            this.http.post<any>(environment.impotUrl, fav)
                .subscribe(data => {
                    if (data.comparatif[fav.fiscal_choice] != undefined && data.comparatif[fav.fiscal_choice].enrichment !== undefined) {
                        this.enrichment = data.comparatif[fav.fiscal_choice].enrichment;
                    }
                    if (data[fav.fiscal_choice].cols !== undefined) {

                        // Graphique compraison des régimes fiscaux
                        if (this.favorite.selling == true) {
                            this.result = data[fav.fiscal_choice].impots.slice(0, this.favorite.selling_year);
                        } else {
                            this.result = data[fav.fiscal_choice].impots;
                        }

                        // 5 dernier + X premier
                        // if (this.result.length > 19) {
                        //     this.result = this.result.slice(0, 19 - 5).concat(this.result.slice(this.result.length - 5, this.result.length));
                        // }

                        if (this.result[this.result.length - 1].loyers_percus > 99999 || this.favorite.total_price > 999999) {
                            this.hideUnit = true;
                        }

                        let colums = this.favorite.fiscal_choice;
                        if (colums == 'Societe IS') {
                            colums = 'SCI IS';
                        }

                        if (this.favorite.fiscal_detailed_view == true) {
                            if (this.favorite.selling == false) {
                                this.displayedColumns = data[colums].cols;
                            } else {
                                this.displayedColumns = data[colums].cols_revente;
                            }
                        } else {
                            if (this.favorite.selling == false) {
                                this.displayedColumns = data[colums].cols_simple;
                            } else {
                                this.displayedColumns = data[colums].cols_revente_simple;
                            }
                        }

                        // Graphique Evolution du capital net
                        this.data_CF_cum = [];
                        const data_Amortissement = [];
                        const data_Enrich = [];

                        var cumul = 0;
                        Object.keys(this.result).forEach(keys => {
                            if (parseInt(keys, 10) < this.favorite.duration) {
                                cumul = cumul + Math.round(this.result[keys].cash_flow);
                                this.data_CF_cum.push(cumul);

                                data_Amortissement.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du));
                                data_Enrich.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du) + cumul);

                                this.amort_moy = Math.round((this.favorite.total_price - this.result[keys].capital_restant_du) / this.favorite.selling_year);
                            }
                        });

                        var d = this.favorite.duration;
                        if (this.favorite.selling == true) {
                            d = this.favorite.selling_year;
                        }
                        this.options_Evol_Capital.xAxis = [
                            {
                                type: 'category',
                                name: 'Année',
                                nameLocation: 'center',
                                nameTextStyle: {
                                    align: 'center',
                                    lineHeight: 50,
                                    fontWeight: 'bold',
                                    fontSize: 18
                                },
                                axisLabel: {
                                    fontSize: 16,
                                },
                                data: Array.from({length: d}, (_, i) => i + 1)
                            }
                        ];
                        if (this.favorite.selling == true) {
                            this.optionsCF.xAxis[0].data = Array.from({length: d}, (_, i) => i + 1);
                        }

                        this.options_Evol_Capital.series = [
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Trésorerie cumulée',
                                color: '#67C2EF',
                                data: this.data_CF_cum
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Capital remboursé',
                                color: '#FABB3D',
                                data: data_Amortissement
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Enrichissement total',
                                color: '#78C447',
                                data: data_Enrich
                            },

                        ];
                        this.capitalData.series = this.options_Evol_Capital.series;

                        // Graphique évolution du Cash Flow
                        const dataCharges = [];
                        const dataLoyers = [];
                        const dataCF = [];
                        const dataPS = [];
                        const dataImpots = [];
                        const dataCredit = [];
                        const dataCS = [];

                        Object.keys(this.result).forEach(keys => {
                            dataCF.push(Math.round(this.result[keys].cash_flow));
                            dataLoyers.push(Math.round(this.result[keys].loyers_percus));
                            dataPS.push(Math.round(this.result[keys].prelev_sociaux));
                            dataCredit.push(Math.round(this.result[keys].annuite));
                            if (fav.fiscal_choice === 'SCI IS') {
                                dataImpots.push(Math.round(this.result[keys].impot_societes));
                                dataCharges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].impot_societes + this.result[keys].annuite)));
                            } else if (fav.fiscal_choice == 'LMP - regime reel') {
                                dataImpots.push(Math.round(this.result[keys].impots_revenus));
                                dataCharges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].prelev_sociaux + this.result[keys].impots_revenus + this.result[keys].annuite + this.result[keys].cotisations_sociales)));
                                dataCS.push(Math.round(this.result[keys].cotisations_sociales));
                            } else {
                                dataImpots.push(Math.round(this.result[keys].impots_revenus));
                                dataCharges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].prelev_sociaux + this.result[keys].impots_revenus + this.result[keys].annuite)));
                            }
                        });
                        // Graphique évolution du Cash Flow
                        var series = [
                            {
                                type: 'bar',
                                name: 'Loyers',
                                color: '#78C447',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataLoyers,
                                lineStyle: {},
                                symbolSize: 0,
                            },
                            {
                                type: 'bar',
                                name: 'Charges',
                                color: '#9C9C9C',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataCharges,
                            },
                            {
                                type: 'bar',
                                name: 'Crédit',
                                color: '#FABB3D',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataCredit,
                            },
                            {
                                type: 'bar',
                                name: 'Impôts',
                                color: '#EB2D2D',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataImpots,
                            },
                            {
                                type: 'bar',
                                name: 'Prélévements sociaux',
                                color: '#FF7777',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataPS,
                            },
                        ];

                        if (fav.fiscal_choice == 'LMP - regime reel') {
                            series.push(
                                {
                                    type: 'bar',
                                    name: 'Cotisations sociales',
                                    color: '#e7abab',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: dataCS,
                                });
                        }

                        series.push({
                            type: 'line',
                            lineStyle: {
                                width: 3
                            },
                            symbolSize: 12,
                            name: 'Cash-Flow',
                            color: '#67C2EF',
                            data: dataCF,
                            stack: '',
                            barWidth: 0,
                        });

                        this.cashflowData.series = series;
                    }

                    setTimeout(function() {
                        this.ready = true;
                    }.bind(this), 5000);


                }, err => {
                    console.log(err);
                });
        } else {
            this.alertService.error('Informations manquante pour la fiscalite.');
        }
    }

    onRentChartInit(ec) {
        this.rentEchartsIntance = ec;
    }

    onPriceChartInit(ec) {
        this.priceEchartsIntance = ec;
    }

    onChargeChartInit(ec) {
        this.chargeEchartsIntance = ec;
    }

    onChartECInit(ec) {
        this.capitalEchartsIntance = ec;
    }

    onChartCFInit(ec) {
        this.cashflowEchartsIntance = ec;
    }

    onChartPopInit(ec) {
        this.popEchartsIntance = ec;
    }

    edit(event, fields = '') {
        if (fields == 'description') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.description, fields);
        } else if (fields == 'comment') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment, fields);
        } else if (fields == 'comment_building') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment_building, fields);
        } else if (fields == 'comment_work') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment_work, fields);
        } else {
            this.adService.updateFavorite(this.favorite);
        }
    }

    onPageChange(val) {
        if (_.difference(val, this.user.user_dashboard.pdf_page).length !== 0) {
            // Checked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, 'action');
            this.user.user_dashboard.pdf_page.push(_.difference(val, this.user.user_dashboard.pdf_page)[0]);
        } else if (_.difference(this.user.user_dashboard.pdf_page, val).length !== 0) {
            // Unchecked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, _.difference(this.user.user_dashboard.pdf_page, val)[0]);
        }
        this.updateDashboard();
    }

    updateDashboard() {
        this.userService.updateDashboard(this.user);
    }

    openPageSelection() {
        $('#pageSelection .isMinimizable').toggleClass('minimize');
    }

    openDropdown() {
        $('#optionDropdown').addClass('optionDropdownOnboarding');
    }

    toFloat(s) {
        return parseFloat(s);
    }

    upFont() {
        this.fontSize++;
        document.getElementById('descFields').style.fontSize = this.fontSize + 'px';
        document.getElementById('workFields').style.fontSize = this.fontSize + 'px';
        document.getElementById('analyzeFields').style.fontSize = this.fontSize + 'px';
        document.getElementById('notesFields').style.fontSize = this.fontSize + 'px';
        if (this.fontSize > 24) {
            document.getElementById('descFields').style.lineHeight = 'normal';
            document.getElementById('workFields').style.lineHeight = 'normal';
            document.getElementById('analyzeFields').style.lineHeight = 'normal';
            document.getElementById('notesFields').style.lineHeight = 'normal';
        }
    }

    downFont() {
        this.fontSize--;
        document.getElementById('descFields').style.fontSize = this.fontSize + 'px';
        document.getElementById('workFields').style.fontSize = this.fontSize + 'px';
        document.getElementById('analyzeFields').style.fontSize = this.fontSize + 'px';
        document.getElementById('notesFields').style.fontSize = this.fontSize + 'px';
        if (this.fontSize <= 24) {
            document.getElementById('descFields').style.lineHeight = '26px';
            document.getElementById('workFields').style.lineHeight = '26px';
            document.getElementById('analyzeFields').style.lineHeight = '26px';
            document.getElementById('notesFields').style.lineHeight = '26px';
        }
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
